import { render, staticRenderFns } from "./rules-hostess.vue?vue&type=template&id=740f6d36&scoped=true"
import script from "./rules-hostess.vue?vue&type=script&lang=js"
export * from "./rules-hostess.vue?vue&type=script&lang=js"
import style0 from "./rules-hostess.vue?vue&type=style&index=0&id=740f6d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f6d36",
  null
  
)

export default component.exports